import React from 'react';
import { Content } from './shared';

const UnitedQuitForLife = () => (
  <Content>
    Live tobacco free with the Quit For Life program through UnitedHealthcare. Visit the Quit For
    Life website to learn more and enroll.
  </Content>
);

export default UnitedQuitForLife;
